<template>
  <div class="gift">
    <nav-bar v-if="!isMobile"></nav-bar>
    <div :class="isMobile ? 'm-content' : 'content'">
      <div class="box">
        <div v-if="isMobile" class="return" @click="$router.push('/')">
          <i class="el-icon-arrow-left" style="color:#fff;font-size: 20px;"></i>
        </div>
        <div class="left">
          <div class="luck">
            <LuckyGrid
                ref="myLucky"
                width="360px"
                height="400px"
                rows="5"
                cols="4"
                :blocks="blocks"
                :prizes="prizes"
                :buttons="buttons"
                :activeStyle="activeStyle"
                :defaultConfig="defaultConfig"
                :defaultStyle="defaultStyle"
                @start="start"
                @end="end"
            />
            <div class="go" @click="start">Go</div>
          </div>
          <div class="user">
            <img src="../../assets/icon/icon_man.png" />
            <span>{{ info.username }}</span>
            <el-button>{{ $t('我的奖品') }}</el-button>
          </div>
          <div class="tips-box">
            <div class="tips"></div>
            <span>{{ $t('抽奖次数') }}&nbsp;<span style="color: #cb1b0f;">{{ info.cjnum }}</span> </span>
          </div>
        </div>
        <div class="center">
          <div class="center-top">
            <div class="title">{{ $t("他们都获奖了") }}</div>
            <div class="rankings">
                <div class="rank-box" :style="{ transform: `translateY(-${currentIndex * itemHeight}px)` }">
                    <div class="ranking-item" v-for="(item, index) in rankings" :key="index">
                        <div class="item-left">
                            <img src="../../assets/icon/g-user.png" />
                            <span>{{ item.tel }}</span>
                        </div>
                        <span>{{ item.goods_name }}</span>
                    </div>
                </div>
            </div>
          </div>
          <div class="center-top">
            <div class="title">{{ $t("活动描述") }}</div>
            <div class="description" v-html="rich">

            </div>
          </div>
        </div>
        <div class="right">
            <div class="right-box">
                <div class="title">{{ $t('我的奖品') }}</div>
                <div class="item" v-for="(item,index) in recordList" :key="index">
                  <div style="display: flex;flex-direction: column;width: 50%;">
                    <span style="font-size: 14px;color: #cb1b0f;">{{ item.goods_name }} + {{ item.money }}</span>
                    <span style="font-size: 12px;color: #999;">{{ item.addtime }}</span>
                  </div>
                  <span style="font-size: 12px;">{{ $t('奖金已经自动发放至您的工作账户中') }}</span>
                </div>
                <div class="empty" v-if="recordList.length == 0">
                    <img src="../../assets/img/empty2.png" />
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { giftList, giftRecord, info, rich, addGift, allGiftRecord } from '../../api/index'
export default {
  name: "LuckyGrid1",
  data() {
    return {
      defaultStyle: {
        background: "#f00",
        borderRadius: "60px",
        shadow: "2px 2px 3px #f00",
        fontColor: "#f00", //文字颜色
        fontSize: "12px", //文字大小
        fontStyle: "微软雅黑", //字体
        fontWeight: "500", //加粗
        lineHeight: "12px", //行高
        wordWrap: true, //换行
        lineClamp: 2, //2行，剩下的...
        lengthLimit: "90%",
      },
      defaultConfig: {
        gutter: "3px",
        speed: 10,
        accelerationTime: 1500,
        decelerationTime: 1500,
      },
      activeStyle: {
        fontColor: "#f00", //文字颜色
        fontSize: "14px", //文字大小
        fontStyle: "微软雅黑", //字体
        fontWeight: "500", //加粗
        background: "#FFF402", //换行
        shadow: "2px 2px 3px #f00",
      },
      blocks: [
        {
          padding: "30px", //可旋转区域与转盘边缘的距离
          background: "#f00", //转盘背景色
          borderRadius: "80px",
          //转盘背景图
          imgs: [
            {
              src: require("../../assets/img/giftBg.png"), //图片url
              top: "0", //图片距顶部距离
              width: "360px", //图片宽
              height: "400px", //图片高
            },
          ],
        },
      ],
      prizes: [
        {
          x: 0,
          y: 0,
          //奖品文字
          fonts: [
            {
              text: "Reward 0.01BTC", //文字
              top: "50%", //文字距顶部距离
              fontColor: "#000", //文字颜色
              fontSize: "9px", //文字大小
              fontStyle: "微软雅黑", //字体
              fontWeight: "500", //加粗
              lineHeight: "12px", //行高
              wordWrap: true, //换行
              lineClamp: 2, //2行，剩下的...
            },
          ],
          //奖品图
          imgs: [
            {
              src: require("../../assets/gift/1.png"), //图片url
              top: "10%", //图片距顶部距离
              width: "30px", //图片宽
              height: "30px", //图片高
            },
          ],
          background: "#eee", //扇形背景色
          range: 10, //当前prize.range/所有prize中range总和
          borderRadius: "10px",
          shadow: "2px 2px 3px #f00",
        }, //1
        {
          x: 1,
          y: 0,
          //奖品文字
          fonts: [
            {
              text: "iphone16 Pro Max", //文字
              top: "50%", //文字距顶部距离
              fontColor: "#000", //文字颜色
              fontSize: "9px", //文字大小
              fontStyle: "微软雅黑", //字体
              fontWeight: "500", //加粗
              lineHeight: "16px", //行高
              wordWrap: true, //换行
              lineClamp: 2, //2行，剩下的...
            },
          ],
          //奖品图
          imgs: [
            {
              src: require("../../assets/gift/2.png"), //图片url
              top: "10%", //图片距顶部距离
              width: "30px", //图片宽
              height: "30px", //图片高
            },
          ],
          background: "#eee", //扇形背景色
          range: 10, //当前prize.range/所有prize中range总和
          borderRadius: "10px",
          shadow: "2px 2px 3px #f00",
        }, //2
        {
          x: 2,
          y: 0,
          //奖品文字
          fonts: [
            {
              text: "Reward 0.05ETH", //文字
              top: "50%", //文字距顶部距离
              fontColor: "#000", //文字颜色
              fontSize: "9px", //文字大小
              fontStyle: "微软雅黑", //字体
              fontWeight: "500", //加粗
              lineHeight: "16px", //行高
              wordWrap: true, //换行
              lineClamp: 2, //2行，剩下的...
            },
          ],
          //奖品图
          imgs: [
            {
              src: require("../../assets/gift/3.png"), //图片url
              top: "10%", //图片距顶部距离
              width: "30px", //图片宽
              height: "30px", //图片高
            },
          ],
          background: "#eee", //扇形背景色
          range: 10, //当前prize.range/所有prize中range总和
          borderRadius: "10px",
          shadow: "2px 2px 3px #f00",
        }, //3
        {
          x: 3,
          y: 0,
          //奖品文字
          fonts: [
            {
              text: "Deposit 100% cashback", //文字
              top: "50%", //文字距顶部距离
              fontColor: "#000", //文字颜色
              fontSize: "9px", //文字大小
              fontStyle: "微软雅黑", //字体
              fontWeight: "500", //加粗
              lineHeight: "16px", //行高
              wordWrap: true, //换行
              lineClamp: 2, //2行，剩下的...
            },
          ],
          //奖品图
          imgs: [
            {
              src: require("../../assets/gift/4.png"), //图片url
              top: "10%", //图片距顶部距离
              width: "30px", //图片宽
              height: "30px", //图片高
            },
          ],
          background: "#eee", //扇形背景色
          range: 10, //当前prize.range/所有prize中range总和
          borderRadius: "10px",
          shadow: "2px 2px 3px #f00",
        }, //4
        {
          x: 3,
          y: 1,
          //奖品文字
          fonts: [
            {
              text: "Deposit 20% cashback", //文字
              top: "50%", //文字距顶部距离
              fontColor: "#000", //文字颜色
              fontSize: "9px", //文字大小
              fontStyle: "微软雅黑", //字体
              fontWeight: "500", //加粗
              lineHeight: "16px", //行高
              wordWrap: true, //换行
              lineClamp: 2, //2行，剩下的...
            },
          ],
          //奖品图
          imgs: [
            {
              src: require("../../assets/gift/5.png"), //图片url
              top: "10%", //图片距顶部距离
              width: "30px", //图片宽
              height: "30px", //图片高
            },
          ],
          background: "#eee", //扇形背景色
          range: 10, //当前prize.range/所有prize中range总和
          borderRadius: "10px",
          shadow: "2px 2px 3px #f00",
        }, //5
        {
          x: 3,
          y: 2,
          //奖品文字
          fonts: [
            {
              text: "Reward 2BTC", //文字
              top: "50%", //文字距顶部距离
              fontColor: "#000", //文字颜色
              fontSize: "9px", //文字大小
              fontStyle: "微软雅黑", //字体
              fontWeight: "500", //加粗
              lineHeight: "16px", //行高
              wordWrap: true, //换行
              lineClamp: 2, //2行，剩下的...
            },
          ],
          //奖品图
          imgs: [
            {
              src: require("../../assets/gift/6.png"), //图片url
              top: "10%", //图片距顶部距离
              width: "30px", //图片宽
              height: "30px", //图片高
            },
          ],
          background: "#eee", //扇形背景色
          range: 10, //当前prize.range/所有prize中range总和
          borderRadius: "10px",
          shadow: "2px 2px 3px #f00",
        }, //6
        {
          x: 3,
          y: 3,
          //奖品文字
          fonts: [
            {
              text: "Reward 0.01ETH", //文字
              top: "50%", //文字距顶部距离
              fontColor: "#000", //文字颜色
              fontSize: "9px", //文字大小
              fontStyle: "微软雅黑", //字体
              fontWeight: "500", //加粗
              lineHeight: "16px", //行高
              wordWrap: true, //换行
              lineClamp: 2, //2行，剩下的...
            },
          ],
          //奖品图
          imgs: [
            {
              src: require("../../assets/gift/7.png"), //图片url
              top: "10%", //图片距顶部距离
              width: "30px", //图片宽
              height: "30px", //图片高
            },
          ],
          background: "#eee", //扇形背景色
          range: 10, //当前prize.range/所有prize中range总和
          borderRadius: "10px",
          shadow: "2px 2px 3px #f00",
        }, //7
        {
          x: 3,
          y: 4,
          //奖品文字
          fonts: [
            {
              text: "Mysterious gift package", //文字
              top: "50%", //文字距顶部距离
              fontColor: "#000", //文字颜色
              fontSize: "9px", //文字大小
              fontStyle: "微软雅黑", //字体
              fontWeight: "500", //加粗
              lineHeight: "16px", //行高
              wordWrap: true, //换行
              lineClamp: 2, //2行，剩下的...
            },
          ],
          //奖品图
          imgs: [
            {
              src: require("../../assets/gift/8.png"), //图片url
              top: "10%", //图片距顶部距离
              width: "30px", //图片宽
              height: "30px", //图片高
            },
          ],
          background: "#eee", //扇形背景色
          range: 10, //当前prize.range/所有prize中range总和
          borderRadius: "10px",
          shadow: "2px 2px 3px #f00",
        }, //8
        {
          x: 2,
          y: 4,
          //奖品文字
          fonts: [
            {
              text: "Reward 1ETH", //文字
              top: "50%", //文字距顶部距离
              fontColor: "#000", //文字颜色
              fontSize: "9px", //文字大小
              fontStyle: "微软雅黑", //字体
              fontWeight: "500", //加粗
              lineHeight: "16px", //行高
              wordWrap: true, //换行
              lineClamp: 2, //2行，剩下的...
            },
          ],
          //奖品图
          imgs: [
            {
              src: require("../../assets/gift/9.png"), //图片url
              top: "10%", //图片距顶部距离
              width: "30px", //图片宽
              height: "30px", //图片高
            },
          ],
          background: "#eee", //扇形背景色
          range: 10, //当前prize.range/所有prize中range总和
          borderRadius: "10px",
          shadow: "2px 2px 3px #f00",
        }, //9
        {
          x: 1,
          y: 4,
          //奖品文字
          fonts: [
            {
              text: "Reward 1BTC", //文字
              top: "50%", //文字距顶部距离
              fontColor: "#000", //文字颜色
              fontSize: "9px", //文字大小
              fontStyle: "微软雅黑", //字体
              fontWeight: "500", //加粗
              lineHeight: "16px", //行高
              wordWrap: true, //换行
              lineClamp: 2, //2行，剩下的...
            },
          ],
          //奖品图
          imgs: [
            {
              src: require("../../assets/gift/10.png"), //图片url
              top: "10%", //图片距顶部距离
              width: "30px", //图片宽
              height: "30px", //图片高
            },
          ],
          background: "#eee", //扇形背景色
          range: 10, //当前prize.range/所有prize中range总和
          borderRadius: "10px",
          shadow: "2px 2px 3px #f00",
        }, //10
        {
          x: 0,
          y: 4,
          //奖品文字
          fonts: [
            {
              text: "Reward 0.1BTC", //文字
              top: "50%", //文字距顶部距离
              fontColor: "#000", //文字颜色
              fontSize: "9px", //文字大小
              fontStyle: "微软雅黑", //字体
              fontWeight: "500", //加粗
              lineHeight: "16px", //行高
              wordWrap: true, //换行
              lineClamp: 2, //2行，剩下的...
            },
          ],
          //奖品图
          imgs: [
            {
              src: require("../../assets/gift/11.png"), //图片url
              top: "10%", //图片距顶部距离
              width: "30px", //图片宽
              height: "30px", //图片高
            },
          ],
          background: "#eee", //扇形背景色
          range: 10, //当前prize.range/所有prize中range总和
          borderRadius: "10px",
          shadow: "2px 2px 3px #f00",
        }, //11
        {
          x: 0,
          y: 3,
          //奖品文字
          fonts: [
            {
              text: "Reward 0.25ETH", //文字
              top: "50%", //文字距顶部距离
              fontColor: "#000", //文字颜色
              fontSize: "9px", //文字大小
              fontStyle: "微软雅黑", //字体
              fontWeight: "500", //加粗
              lineHeight: "16px", //行高
              wordWrap: true, //换行
              lineClamp: 2, //2行，剩下的...
            },
          ],
          //奖品图
          imgs: [
            {
              src: require("../../assets/gift/12.png"), //图片url
              top: "10%", //图片距顶部距离
              width: "30px", //图片宽
              height: "30px", //图片高
            },
          ],
          background: "#eee", //扇形背景色
          range: 10, //当前prize.range/所有prize中range总和
          borderRadius: "10px",
          shadow: "2px 2px 3px #f00",
        }, //12
        {
          x: 0,
          y: 2,
          //奖品文字
          fonts: [
            {
              text: "Reward 0.5ETH", //文字
              top: "50%", //文字距顶部距离
              fontColor: "#000", //文字颜色
              fontSize: "9px", //文字大小
              fontStyle: "微软雅黑", //字体
              fontWeight: "500", //加粗
              lineHeight: "16px", //行高
              wordWrap: true, //换行
              lineClamp: 2, //2行，剩下的...
            },
          ],
          //奖品图
          imgs: [
            {
              src: require("../../assets/gift/12.png"), //图片url
              top: "10%", //图片距顶部距离
              width: "30px", //图片宽
              height: "30px", //图片高
            },
          ],
          background: "#eee", //扇形背景色
          range: 10, //当前prize.range/所有prize中range总和
          borderRadius: "10px",
          shadow: "2px 2px 3px #f00",
        }, //13
        {
          x: 0,
          y: 1,
          //奖品文字
          fonts: [
            {
              text: "Deposit 100% cashback", //文字
              top: "50%", //文字距顶部距离
              fontColor: "#000", //文字颜色
              fontSize: "9px", //文字大小
              fontStyle: "微软雅黑", //字体
              fontWeight: "500", //加粗
              lineHeight: "16px", //行高
              wordWrap: true, //换行
              lineClamp: 2, //2行，剩下的...
            },
          ],
          //奖品图
          imgs: [
            {
              src: require("../../assets/gift/14.png"), //图片url
              top: "10%", //图片距顶部距离
              width: "30px", //图片宽
              height: "30px", //图片高
            },
          ],
          background: "#eee", //扇形背景色
          range: 10, //当前prize.range/所有prize中range总和
          borderRadius: "10px",
          shadow: "2px 2px 3px #f00",
        }, //14
      ],
      buttons: [
        {
          // x: 1,
          // y: 1,
          // borderRadius: "80px",
          // background: "#FFF402",
          // shadow: "2px 2px 3px #f00",
          // fonts: [
          //   {
          //     text: "Go", //文字
          //     left: "60%",
          //     top: "75px", //文字距顶部距离
          //     fontColor: "#fff", //文字颜色
          //     fontSize: "32px", //文字大小
          //     fontStyle: "微软雅黑", //字体
          //     fontWeight: "500", //加粗
          //     lineHeight: "16px", //行高
          //   },
          // ],
          // 抽奖按钮图
          // imgs: [
          //   {
          //     src: require("../../assets/img/btn.png"), //图片url
          //     top: "0", //图片距顶部距离
          //     left: "65%",
          //     width: "120px", //图片宽
          //     height: "170px", //图片高
          //     borderRadius: "80px",
          //   },
          // ],
        },
      ],
      rankings: [], // 全部中奖记录
      currentIndex: 0,
      itemHeight: 50,
      timer: null,
      recordList: [], // 我的抽奖记录
      info: {},
      rich: '', //

    };
  },
  computed: {
    ...mapGetters("device", ["isMobile"]),
  },
  mounted() {
    this.startScrolling();
    this.getList()
    this.getRecord()
    this.getInfo()
  },
  methods: {
    // 获取抽奖列表
    getList() {
      giftList().then(res=> {
        if (res.code == 0) {
          var result = res.data
          result.map((el,i)=> {
            this.prizes[i].fonts[0].text = el.name
            this.prizes[i].fonts[0].id = el.id
            this.prizes[i].imgs[0].src = el.pic
          })
        }
      })
    },
    // 抽奖记录
    getRecord() {
      giftRecord().then(res=> {
        if (res.code == 0) {
          this.recordList = res.data
        }
      })

      allGiftRecord().then(res=> {
        if (res.code == 0) {
          this.rankings = res.data
        }
      })
    },
    // 个人信息
    getInfo() {
      info().then(res=> {
        if (res.code == 0) {
          this.info = res.data.info
        }
      })

      rich({id: 22}).then(res=> {
        if (res.code == 0) {
          this.rich = res.data.content
        }
      })
    },
    start() {
      if (this.info.cjnum == 0) {
        return this.$message({
          message: this.$t('暂无抽奖次数'),
          type: 'warning'
        })
      }
      // 开始游戏
      // setTimeout(() => {
        // 结束游戏, 并抽第0号奖品
        addGift().then(res=> {
          if (res.code == 0) {
            this.$refs.myLucky.play();
            this.prizes.forEach((el,i)=> {
              if (res.data.id == el.fonts[0].id) {
                this.$refs.myLucky.stop(i,1);
              }
            })
          }
        })

      // }, 1000);
    },
    // 游戏结束触发 end 回调
    end(prize) {
      // alert("恭喜中奖: " + prize.fonts[0].text);
      this.$message({
        message: prize.fonts[0].text,
        type: 'success'
      })
      this.getRecord()
      this.getInfo()
    },
    startScrolling() {
     this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.rankings.length;
      }, 1500); // 每2秒滚动一次
    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
};
</script>

<style lang="scss" scoped>
.gift {
  .content {
    background: #f8f8f8;
    background: url("../../assets/img/bg2.jpg") no-repeat;
    background-size: 100%;
    background-size: cover;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    min-height: 100vh;
    padding: 80px 0 30px 0;
    width: 100%;

    .box {
      width: 65%;
      margin: 0 auto;
      display: flex;

      .left,
      .center,
      .right {
        flex: 1;
        /* justify-content: center; */
      }

      .luck {
        width: 330px;
        margin: 0 auto;
        position: relative;

        .go {
            width: 120px; //图片宽
            height: 150px; //图片高
            line-height: 150px;
            text-align: center;
            font-size: 32px;
            position: absolute;
            top: calc(175px - 61px);
            left: calc(165px - 45px);
            border-radius: 24px;
            color: #fff;
            background: url('../../assets/img/btn.png') no-repeat;
            z-index: 999;
            cursor: pointer;
        }
      }

      .user {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        margin-top: 20px;

        img {
            width: 30px;
            height: 30px;
        }

        span {
            padding: 0 20px;
            font-size: 18px;
            font-weight: 600;
        }

        :deep(.el-button) {
            color: #cb1b0f;
            background-color: #ecb844;
            border: none;
            border-radius: 12px;
            font-size: 14px;
            padding: 8px 20px;
        }
      }

      .tips-box {
        align-items: center;
        background: #ffdf7a;
        border-radius: 15px;
        display: flex;
        height: 30px;
        width: 45%;
        margin: 20px auto;
        padding: 0 20px;

        .tips {
            background: #d4237a;
            border-radius: 50%;
            display: flex;
            height: 5px;
            width: 5px;
        }

        span {
            padding: 0 15px;
            font-size: 14px;
        }
      }

      .center-top {
        width: 90%;
        margin: 0 auto 20px auto;

        .title {
          align-items: center;
          background-image: linear-gradient(#ecb844, #e3b95b);
          border-top-left-radius: 15px;
          border-top-right-radius: 15px;
          box-sizing: border-box;
          display: flex;
          height: 40px;
          justify-content: space-between;
          padding: 0 5%;
          width: 100%;
          color: #cb1b0f;
          font-size: 15px;
          font-weight: 600;
        }

        .rankings {
          height: 150px; /* 设置合适的高度 */
          overflow: hidden;
          background-color: #feefcc;
          border-radius: 0 0 12px 12px;
        }

        .description {
            background-color: #feefcc;
            padding: 10px;
            border-radius: 0 0 12px 12px;
        }
        .rank-box {
            transition: transform 1s ease;
        }
        .ranking-item {
          /* padding: 12px 0; */
          height: 50px;
          line-height: 50px;
          margin: 0 20px;
          border-bottom: 1px dashed #e7c09c;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;

          .item-left {
            display: flex;
            align-items: center;
          }

          img {
            width: 25px;
            height: 25px;
            margin-right: 10px;
          }
        }
      }
    }

    .right {
        background-color: #feefcc;
        border-radius: 12px;

        .right-box {
            padding: 20px 10px;

            .title {
                border-left: 5px solid #2080e5;
                color: #333;
                display: flex;
                font-size: 16px;
                justify-content: space-between;
                text-indent: 15px;
            }

            .item {
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-bottom: 1px dashed #e7c09c;
              padding: 15px 0;
              margin: 5px 10px;
            }

            .empty {
                width: 160px;
                height: 160px;
                margin: 10px auto;

                img {
                    width: 160px;
                    height: 160px;
                }
            }
        }
    }
  }

  .m-content {
    background: #f8f8f8;
    background: url("../../assets/img/bg2.jpg") no-repeat;
    background-size: 100%;
    background-size: cover;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    min-height: 100vh;
    /* padding: 20px 0 0; */
    width: 100%;

    .return {
      padding: 20px 0 10px 0;
    }

    .box {
      /* width: 65%; */
      display: flex;
      flex-direction: column;

      .left,
      .center,
      .right {
        flex: 1;
        /* justify-content: center; */
      }

      .center {
        padding: 0 6px;
      }

      .luck {
        width: 360px;
        margin: 0 auto;
        position: relative;

        .go {
            width: 120px; //图片宽
            height: 150px; //图片高
            line-height: 150px;
            text-align: center;
            font-size: 32px;
            position: absolute;
            top: calc(175px - 61px);
            left: calc(165px - 45px);
            border-radius: 24px;
            color: #fff;
            background: url('../../assets/img/btn.png') no-repeat;
            z-index: 999;
            cursor: pointer;
        }
      }

      .user {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        margin-top: 20px;

        img {
            width: 30px;
            height: 30px;
        }

        span {
            padding: 0 20px;
            font-size: 18px;
            font-weight: 600;
        }

        :deep(.el-button) {
            color: #cb1b0f;
            background-color: #ecb844;
            border: none;
            border-radius: 12px;
            font-size: 14px;
            padding: 8px 20px;
        }
      }

      .tips-box {
        align-items: center;
        background: #ffdf7a;
        border-radius: 15px;
        display: flex;
        height: 30px;
        width: 45%;
        margin: 20px auto;
        padding: 0 20px;

        .tips {
            background: #d4237a;
            border-radius: 50%;
            display: flex;
            height: 5px;
            width: 5px;
        }

        span {
            padding: 0 15px;
            font-size: 14px;
        }
      }

      .center-top {
        margin: 20px 0;

        .title {
          align-items: center;
          background-image: linear-gradient(#ecb844, #e3b95b);
          border-top-left-radius: 15px;
          border-top-right-radius: 15px;
          box-sizing: border-box;
          display: flex;
          height: 40px;
          justify-content: space-between;
          padding: 0 5%;
          width: 100%;
          color: #cb1b0f;
          font-size: 15px;
          font-weight: 600;
        }

        .rankings {
          height: 150px; /* 设置合适的高度 */
          overflow: hidden;
          background-color: #feefcc;
          border-radius: 0 0 12px 12px;
        }

        .description {
            background-color: #feefcc;
            padding: 10px;
            border-radius: 0 0 12px 12px;
        }
        .rank-box {
            transition: transform 1s ease;
        }
        .ranking-item {
          /* padding: 12px 0; */
          height: 50px;
          line-height: 50px;
          margin: 0 20px;
          border-bottom: 1px dashed #e7c09c;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;

          .item-left {
            display: flex;
            align-items: center;
          }

          img {
            width: 25px;
            height: 25px;
            margin-right: 10px;
          }
        }
      }
    }

    .right {

        margin-bottom: 30px;
        padding: 0 6px;

        .right-box {
            padding: 20px 10px;
            background-color: #feefcc;
            border-radius: 12px;

            .title {
                border-left: 5px solid #2080e5;
                color: #333;
                display: flex;
                font-size: 16px;
                justify-content: space-between;
                text-indent: 15px;
            }

            .empty {
                width: 160px;
                height: 160px;
                margin: 10px auto;

                img {
                    width: 160px;
                    height: 160px;
                }
            }
        }
    }
  }
}
</style>
